import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type Language = 'ar' | 'en';

interface LanguageState {
  language: Language;
  setLanguage: (lang: Language) => void;
  toggleLanguage: () => void;
  isRTL: boolean;
}

const getInitialLanguage = (): Language => {
  if (typeof window !== 'undefined') {
    return (localStorage.getItem('language') as Language) || 'en';
  }
  return 'en';
};

const initialLang = getInitialLanguage();

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      language: initialLang,
      isRTL: initialLang === 'ar',
      setLanguage: (lang: Language) => {
        set({ language: lang, isRTL: lang === 'ar' });
        if (typeof window !== 'undefined') {
          document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
          document.documentElement.lang = lang;
        }
      },
      toggleLanguage: () => {
        set((state) => {
          const newLang = state.language === 'ar' ? 'en' : 'ar';
          if (typeof window !== 'undefined') {
            document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
            document.documentElement.lang = newLang;
          }
          return { language: newLang, isRTL: newLang === 'ar' };
        });
      },
    }),
    {
      name: 'language-storage',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        if (state && typeof window !== 'undefined') {
          document.documentElement.dir = state.language === 'ar' ? 'rtl' : 'ltr';
          document.documentElement.lang = state.language;
        }
      },
    }
  )
);
